import { useState, useEffect } from "react"

interface TypingEffectProps {
  text: string
  speed?: number
}

const TypingEffect: React.FC<TypingEffectProps> = ({ text, speed = 50 }) => {
  const [displayedText, setDisplayedText] = useState("")

  useEffect(() => {
    let index = 0
    const interval = setInterval(() => {
      // Safely get the character using charAt (returns '' if index is out of range)
      const nextChar = text.charAt(index)
      if (nextChar) {
        setDisplayedText((prev) => prev + nextChar)
        index++
      } else {
        clearInterval(interval)
      }
    }, speed)
    return () => clearInterval(interval)
  }, [text, speed])

  return <span>{displayedText}</span>
}

export default TypingEffect
